import { useNavigate } from "react-router-dom";
import { BUTTON_DASHBOARD, BUTTON_TRAINING_COMPETENCY, HEADER_PAGE_ACTION_CLASS_NAME } from "./constants";
import "./style.css";
import { Button, Container, Navbar, Nav } from "react-bootstrap";
import { APP_URLS } from "../../constants/appConstants";
import LogoutButton from "../LogOutButton/LogoutButton";

const Header = () => {
    const navigate = useNavigate();

    const renderAdminAction = () => {
        return (
            <Navbar bg="light" variant="light" expand="lg" sticky="top" fixed="top" className={HEADER_PAGE_ACTION_CLASS_NAME}>
                <Container>
                    <Navbar.Collapse className="justify-content-end">
                        <LogoutButton />
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    };

    return renderAdminAction();
};

export default Header;
